import React, { Fragment } from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import Modal from 'react-awesome-modal'

const ModalRegulationCustom = ({ isOpen, handleClose }) => {
  return <Modal
    width='1160'
    height='500'
    effect='fadeInUp'
    visible={isOpen}
  >
    <Fragment>
      <div
        className={`col-12 border-bottom-lg border-color-featured bg-white py-3 mr-auto ml-auto`}
      >
        <div className='row px-3'>
          <div className='col'>
            <h2 className='txt-font-title'>Termos do regulamento</h2>
          </div>
          <div className='col-auto'>
            <Button
              name={'Close'}
              className='btn btn-double btn-flat btn-icon-only btn-icon mx-0'
              iconName='icon_close icon-sm'
              text=''
              aria-label='Fechar'
              onClick={handleClose}
            />
          </div>
        </div>
        <div className='col-12'>
          <div className='row px-3'>
            <div className='col mx-0 mt-2 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'>
              <div className='row mr-1'>
                <div className='col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm' style={{ height: '250px' }}>
                  <p className='mb-2'>
                    1. O Cartão Pré-Pago Like+ permite a realização de pagamentos com a função crédito à vista de produtos e serviços em estabelecimentos credenciados à rede MasterCard, em todo Brasil, mediante o uso de senha numérica pessoal em transações presenciais ou online, por meio de e-commerces e marketing direto.
                  </p>
                  <p className='mb-2'>
                    2. Os cartões serão enviados aos Usuários acompanhados de um “Welcome Kit”, composto pelo cartão e envelope de segurança. O Cartão Pré-Pago Like+ será entregue ao Usuário, o qual poderá cadastrar a senha de utilização por meio da Central de Atendimento (11) 4020-0221 ou do site www.cartaolikemais.com.br, na opção “primeiro acesso”, no prazo de até 60 (sessenta) dias contados da confirmação do resgate da premiação.
                  </p>
                  <p className='mb-2'>
                    3. A Central de Atendimento estará disponível de segunda a sexta, das 9h às 18 horas, pelo telefone (11) 4020-0221, e poderá ser utilizada pelos Usuários para sanar dúvidas quanto ao uso do Cartão Pré-Pago Like+, cadastrar senha para utilização do cartão, consultar o saldo existente, bloqueio de cartão por motivos de perda/roubo ou extravio. As mesmas funções poderão ser realizadas por meio do site www.cartaolikemais.com.br na opção “acesse seu cartão”.
                  </p>
                  <p className='mb-1'>
                    4. Durante o período de validade do Cartão Pré-Pago Like+, em razão de perda ou extravio, o Usuário poderá solicitar a 2ª (segunda) via do cartão, que lhe será enviado no prazo de até 30 (trinta) dias úteis contados da solicitação, onde os custos relacionados a emissão de um novo cartão serão fornecidos no ato da solicitação do novo cartão, a ser descontado do saldo existente no cartão, desde que haja saldo suficiente para tanto. Caso o Usuário não tenha saldo suficiente não será possível a emissão de novo cartão.
                  </p>
                  <p className='mb-2'>
                    4.1 Os créditos então existentes, se não utilizados, serão transferidos para o novo cartão, em nome do mesmo titular, em substituição ao anterior, que será cancelado. Se não houver saldo suficiente referida operação não poderá ser realizada.
                  </p>
                  <p className='mb-1'>
                    5. O Usuário tem ciência de que será descontado do saldo existente em seu cartão a quantia de R$4,90 (quatro reais e noventa centavos) por mês, à título de tarifa de manutenção do cartão, quantia esta que será abatida diretamente do saldo do cartão do premiado. Esta tarifa de manutenção será cobrada do Usuário a partir do 6º mês inclusive. Esta prazo é contado a partir do mês de emissão do cartão.
                  </p>
                  <p className='mb-2'>
                    5.1. Na hipótese de insuficiência de crédito no cartão para débito do valor integral da tarifa de manutenção no 1º dia útil de cada mês, os valores remanescentes de mensalidade (“saldo remanescente”) serão liquidados por novas cargas eventualmente realizadas dentro do mês em que o saldo remanescente foi gerado até que se complete o valor da mensalidade previsto na cláusula 5.
                  </p>
                  <p className='mb-2'>
                    6. O cartão poderá ser cancelado pela Mastercard em caso de fraude e as quantias existentes no cartão permanecerão bloqueadas até que o problema seja resolvido. Após solução do problema, um novo cartão com o mesmo saldo poderá ser emitido, desde que a fraude não decorra de ação ou omissão do Usuário.
                  </p>
                  <p className='mb-2'>
                    7. Não haverá possibilidade de saque do valor creditado no Cartão Pré-Pago Like+ ou qualquer outra forma de conversão dos créditos em moeda corrente.
                  </p>
                  <p className='mb-2'>
                    8. Os créditos do cartão não utilizados em até 12 meses contados da data do crédito serão automaticamente expirados/cancelados, independentemente de aviso prévio, e não poderão mais ser utilizados pelos Usuários.
                  </p>
                  <p className='mb-2'>
                    9. Os créditos inseridos no cartão poderão ser cancelados nas seguintes hipóteses:
                  </p>
                  <p className='mb-1 ml-3'>
                    a) Erro no cômputo dos créditos;
                  </p>
                  <p className='mb-2 ml-3'>
                    b) Fraude ou tentativa de fraude pelo Usuário, através de códigos maliciosos, vírus ou quaisquer outras formas que visem à obtenção de vantagens indevidas.
                  </p>
                  <p className='mb-2'>
                    9.1 Nas hipóteses de cancelamento previstas nos subitens a e b da cláusula anterior, o Usuário será informado através de e-mail sobre o motivo do cancelamento dos pontos, com identificação de quantos pontos foram cancelados.
                  </p>
                  <p className='mb-2'>
                    10. Os créditos inseridos no Cartão Pré-Pago Like+ são pessoais e não se transmitirão por sucessão ou herança, sendo que, em caso de falecimento do Usuário, o seu cadastro será encerrado e os créditos eventualmente existentes serão cancelados, sem direito a compensação ou indenização de qualquer natureza.
                  </p>
                  <p className='mb-2'>
                    11. Eventuais dúvidas ou problemas decorrentes da entrega dos Cartão Pré-Pago Like+ deverão ser sanados pelo Usuário diretamente na Central de Atendimento, pelo telefone (11) 4020-0221 ou por meio do site www.cartaolikemais.com.br.
                  </p>
                  <p className='mb-2'>
                    12. A utilização do Cartão Pré-Pago Like+ implica na aceitação e total concordância com as regras dispostas no presente Termo de Uso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 pt-3'>
          <div className='row  align-items-center h-100  px-3'>
            <div className='modal-back col-2 px-0 txt-left mr-auto d-none d-md-block' />
            <div className='modal-back col-12 col-md-4 px-0 txt-right d-none d-md-block'>
              <Button
                id={`Agree-desktop-like-plus}`}
                name={'Agree'}
                className='btn btn-featured mx-0'
                text='Concluir'
                onClick={handleClose}
              />
            </div>
            <div className='modal-back col-12 col-md-4 px-0 txt-right d-block d-md-none'>
              <Button
                id={`Agree-mobile-like-plus`}
                name={'Agree'}
                className='cart-done btn-featured nowrap'
                text='Concluir'
                onClick={handleClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  </Modal>
}

ModalRegulationCustom.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func
}
export default ModalRegulationCustom



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/ModalRegulationCustom.js